<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
        <div class="track-shipment update-user">
            <loading-charts v-if="loadingUser" class="loading-charts"/>
            <div class="user-info">
                <div class="inner-overflow-container" id="inner-overflow-container">
                    <div class="header-track-shipment">
                            <div class="header-track-inner">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                            <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                            <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                            <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                            <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                            <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                            <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                        </g>
                                        <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                        <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                        <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                        </g>
                                    </g>
                                    </svg>
                                    <p>Pickups</p>
                            </div>
                        </div>
                    <div v-if="(AdminUser || InternalAdmin)">
                        <div class="confirmLabelContainer">
                            <select name="routeCodeSelect" v-model="selectedShipment" id="routeCodeSelect">
                                <option :value="'Current'">New Pickup</option>
                                <option :value="'In Transit'">Pickup Initiated</option>
                            </select>
                        </div>    
                        <pickup-table  @refreshAfterVoid="refreshAfterVoid($event)" :cognitoUser="user" :selectedShipment="selectedShipment" :selectedDates="selectedDates" :jwtToken="jwtToken" :userData="userData"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {createCognitoUser} from '../../../graphql/mutations'
import {Auth, API} from 'aws-amplify'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import PickupTable from '../PickupDashboard/PickupTable.vue';
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue'

export default {
    data(){
        return{
            user: {},
            selectedShipment: 'Current',
            jwtToken: null,
            loadingUser: false,
            userData: {},
            userDataCognito: {},
            refreshKey: 0,
            placeHolder: "Search for address",
            validateCustomAddress: false,
            userCustomAddress: "",
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            createCognitoUserInput: {
                email: "",
                username: "",
                accountNo: "",
                locationID: ""
            },
            selectedUserData:{
                locationID: ""
            }
        }
    },
    components:{
        LoadingCharts,
        AlertUser,
        PickupTable,
        SignedInUserInfo
    },
    mounted(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
                if (!this.AdminUser && !this.InternalAdmin) {
                    alert("Access denied to pickup dashboard")
                    // Redirect to the shipment page
                    this.$router.push('/ShipmentDashboard');
                }
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
    methods:{
        async checkBoxSelectID(event){
            this.createCognitoUserInput.locationID = event;
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($UserName: String!){
                        getUser(userName: $UserName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            UserName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async createCognitoUserFunc(){
            if(this.createCognitoUserInput.locationID == ""){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a location for user."
                return;
            }

            if(this.createCognitoUserInput.email == ""){
                this.toggleAlertBox = true;
                this.alertMessage = "Enter an email for user."
                return;
            }

            if(this.createCognitoUserInput.username == ""){
                this.toggleAlertBox = true;
                this.alertMessage = "Enter user name."
                return;
            }

            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: createCognitoUser,
                    variables: {
                        input:{
                            username: this.createCognitoUserInput.username,
                            email: this.createCognitoUserInput.email,
                            accountNo: this.userData.AccountNo,
                            locationID: this.createCognitoUserInput.locationID
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userDataCognito = userReturnData.data.updateUser;
                this.GetUserGraphQL();
                this.toggleAlertBox = true;
                this.alertMessage = "Created user."
                let obj = this.createCognitoUserInput;
                for (const key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        obj[key] = '';
                    }
                }
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create user"
                this.GetUserGraphQL();
            }finally{
                this.loadingUser = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #000;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}

html{
    background-color: #f3f3f3;
}

.main-container{
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container{
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.inner-overflow-container{
    width: 100%;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
}

.header-track-inner svg{
    height: 22px;
    margin: 0;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    width: fit-content;
    height: fit-content;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.create-user{
    flex-basis: 40%;
}

.update-user{
    flex-basis: 60%;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.confirmLabelContainer{
    margin-bottom: 5px;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 10px;
}

.auto-complete-container{
    margin-top: 5px !important;
    width: 90%;
    margin-left: 10px;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

@media only screen and (max-width: 1300px) {
    .inner-container{
        width: 85%;
    }
}

@media only screen and (max-width: 1000px) {
    .data-container-main, .inner-track-shipment-container{
        flex-wrap: wrap;
    }

    .track-shipment{
        flex-basis: 70%;
    }

    .data-container{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container{
        width: 95%;
    }

    .data-container{
        flex-basis: 80%;
    }

    .track-shipment{
        flex-basis: 80%;
    }

    .confirmContainerInner{
        flex-wrap: wrap;
    }

    .notifications{
        margin-top: 5px;
    }
}
</style>